'use client';

import { Card } from '@components/card';
import { Swiper, SwiperSlide } from 'swiper/react';

import type { UseCasesCard } from '../types';

interface Props {
  cards: UseCasesCard[];
}

export const UseCasesMobileSection = ({ cards }: Props) => {
  return (
    <div className="flex h-[227px] md:hidden">
      <Swiper
        spaceBetween={16}
        slidesPerView="auto"
        className="ml-[-8px]! pr-14! pl-6!"
      >
        {cards?.map(({ id, icon, description }) => {
          return (
            <SwiperSlide key={id}>
              <Card rounded="16">
                <div className="flex size-full flex-col justify-between p-6">
                  <div>
                    <span className="text-[16px] leading-[24px] tracking-[-0.16px]">
                      {description}
                    </span>
                  </div>
                  <div className="bg-surface-base-blur flex size-8 items-center justify-center rounded-lg">
                    {icon}
                  </div>
                </div>
              </Card>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
};
